import { FunctionComponent } from 'react'
import { Icon } from '../../shared/Icon'
import { ModeConfig } from './DictationWidget.types'
import styles from './DictationWidget.module.scss'

type Props = {
  activeMode: ModeConfig
  canSwitch: boolean
  modeOpen: boolean
  onToggle: () => void
}

/** Module actif en tête du panneau Statistiques ; ouvre le choix des autres modules du widget. */
export const StatsPanelModeSwitch: FunctionComponent<Props> = ({
  activeMode,
  canSwitch,
  modeOpen,
  onToggle,
}) => {
  const content = (
    <>
      <span className={styles.ip} data-mode="stats">
        <Icon icon={activeMode.iconName} size="pico" color="currentColor" />
      </span>
      <span className={styles.ipLabel}>{activeMode.label}</span>
    </>
  )

  if (!canSwitch) return <span className={styles.headerMode}>{content}</span>

  return (
    <button
      type="button"
      className={styles.headerMode}
      // Évite que le popover ouvert se ferme puis se rouvre sur le même clic.
      onMouseDown={(e) => e.nativeEvent.stopPropagation()}
      onClick={onToggle}
      aria-label="Changer de module"
      aria-expanded={modeOpen}
    >
      {content}
      <Icon icon="chevron" size="pico" rotate={modeOpen ? 180 : 0} color="currentColor" />
    </button>
  )
}
